module.exports = __webpack_public_path__ + "static/media/Piercing-nose-highnostrilsymmetry.00eed455.png";